export default function FormItem ({type, value, handleChange, label, required, labelHref, descClassName}) {
    return (
        <label className="form-item">
            <input
                className="form-item__entry"
                type={type} value={value}
                onChange={handleChange}
                required={required? "required": ""}
            />
            <div className={`form-item__desc ${descClassName ? descClassName : ""}`}>{
                labelHref ? <a href={labelHref} target="_blank" rel="noopener noreferrer">{label}</a> :
                label
            }</div>
        </label>
    )
};